function iosOnlyCallDecorator(fn) {
    return () => {
        if (navigator.userAgent.match(/(iPhone|iPod|iPad)/i) && fn instanceof Function) {
            fn();
        }
    };
}

function setFormFieldPointerEvents(value) {
    let nodes = document.querySelectorAll('input, select, textarea');

    for (var node of nodes) {
        node.style.pointerEvents = value;
    }
}

const iosOnlyFixes = {
    // event handler references in case if they needs to be removed in some special cases
    _touchStartEventHandler() {
        setFormFieldPointerEvents('auto');
    },
    _touchMoveEventHandler() {
        setFormFieldPointerEvents('none');
    },
    _touchEndEventHandler() {
        setTimeout(function() {
            setFormFieldPointerEvents('auto');
        }, 0);
    },
    applyNoInputScrollFix() {
        document.addEventListener('DOMContentLoaded', iosOnlyFixes._touchMoveEventHandler);
        document.addEventListener('touchstart', iosOnlyFixes._touchStartEventHandler);
        document.addEventListener('touchmove', iosOnlyFixes._touchMoveEventHandler);
        document.addEventListener('touchend', iosOnlyFixes._touchEndEventHandler);
    }
};

for (var fixName in iosOnlyFixes) {
    if (fixName[0] !== '_') {
        iosOnlyFixes[fixName] = iosOnlyCallDecorator(iosOnlyFixes[fixName]);
    }
}

export default iosOnlyFixes;
